export const GetRegistrationStepsUrl = "/admin/api/registration_steps";
export const GetRegistrationStepsColumnUrl = (columnId: number, page: number, search: string | null, filters: { qualification?: string[] }) => {
  const params = new URLSearchParams({ page: String(page) });
  if (search?.trim()) params.set("q", search.trim());
  if (filters.qualification?.length) params.set("qualification", filters.qualification.join(","));
  return `/admin/api/registration_steps/${columnId}?${params.toString()}`;
};
export const PutRegistrationStepUrl = (registrationStepId: number) =>
  `/admin/api/registration_steps/${registrationStepId}`;

export const DRAG_KEY = "cardInfo";
